import React from 'react';
import CreateClassModal from '../CreateClassModal/CreateClassModal';
import { Card, List, Typography, Divider, Alert } from 'antd';
import { 
  VideoCameraOutlined,
  UploadOutlined,
  CheckCircleOutlined,
  InfoCircleOutlined,
  ClockCircleOutlined,
  PlayCircleOutlined
} from '@ant-design/icons';

const { Title, Text, Paragraph } = Typography;

function UploadVideo() {
  return (
    <div className='upload-video-container'> 
      <div style={{ textAlign: 'center', marginBottom: 32 }}>
        <Title level={2} style={{ marginBottom: 8 }}>
          <VideoCameraOutlined style={{ marginRight: 12, color: '#1890ff' }} />
          Upload Class Videos
        </Title>
        <Paragraph type="secondary" style={{ fontSize: 16 }}>
          Create your class and upload video lessons
        </Paragraph>
      </div>

      <div className='upload-video-layout'>
        {/* Main Create Button */}
        <div style={{ textAlign: 'center', marginBottom: 48 }}>
          <CreateClassModal />
          <Paragraph type="secondary" style={{ marginTop: 16 }}>
            Start by creating a new class
          </Paragraph>
        </div>

        <Divider />

        {/* Simple Instructions */}
        <div style={{ maxWidth: 800, margin: '0 auto' }}>
          <Title level={4} style={{ marginBottom: 24 }}>
            <InfoCircleOutlined style={{ marginRight: 8 }} />
            How It Works
          </Title>

          <Card style={{ marginBottom: 24 }}>
            <List
              itemLayout="horizontal"
              dataSource={[
                {
                  icon: <PlayCircleOutlined style={{ color: '#52c41a', fontSize: 20 }} />,
                  title: '1. Create Class',
                  description: 'Select a teacher and set up your class'
                },
                {
                  icon: <UploadOutlined style={{ color: '#1890ff', fontSize: 20 }} />,
                  title: '2. Upload Videos',
                  description: 'Add your video lessons - they upload one at a time'
                },
                {
                  icon: <CheckCircleOutlined style={{ color: '#faad14', fontSize: 20 }} />,
                  title: '3. Add Details',
                  description: 'Enter titles, descriptions, and upload thumbnails'
                },
                {
                  icon: <ClockCircleOutlined style={{ color: '#722ed1', fontSize: 20 }} />,
                  title: '4. Publish',
                  description: 'Review and publish your class for students'
                }
              ]}
              renderItem={item => (
                <List.Item>
                  <List.Item.Meta
                    avatar={item.icon}
                    title={<Text strong>{item.title}</Text>}
                    description={item.description}
                  />
                </List.Item>
              )}
            />
          </Card>

          {/* Important Notes */}
          <Alert
            message="Important Notes"
            description={
              <div style={{ marginTop: 8 }}>
                <Paragraph>
                  <CheckCircleOutlined style={{ color: '#52c41a', marginRight: 8 }} />
                  Videos upload sequentially (one at a time)
                </Paragraph>
                <Paragraph>
                  <CheckCircleOutlined style={{ color: '#52c41a', marginRight: 8 }} />
                  First video becomes the class introduction
                </Paragraph>
                <Paragraph>
                  <CheckCircleOutlined style={{ color: '#52c41a', marginRight: 8 }} />
                  Supported formats: MP4, MOV, AVI (max 2GB each)
                </Paragraph>
              </div>
            }
            type="info"
            showIcon
          />
        </div>
      </div>
    </div>
  );
}

export default UploadVideo;